/* [04] V6 2026-10-29: a TAP on the dock's "Swipe up for details" cue scrolls
   smoothly to the product information. The swipe itself is the V5 native
   gesture (pdp-editorial-04.js), nothing here touches touch events.
   The scroll is animated explicitly (ease-out cubic) on the real page scroller,
   with the theme's CSS scroll-behavior:smooth paused, so it is identical on
   every browser. */
(() => {
  'use strict';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let anim = 0;

  function pageScroller() {
    const w = document.querySelector('.page-wrapper');
    if (w && w.scrollHeight > w.clientHeight + 2 && /(auto|scroll)/.test(getComputedStyle(w).overflowY)) return w;
    return document.scrollingElement || document.documentElement;
  }

  function scrollToDetails(dock) {
    const root = dock.closest('.product-information') || document;
    const target = root.querySelector('.product-details');
    if (!target) return;
    const owner = pageScroller();
    const isDoc = owner === document.scrollingElement || owner === document.documentElement;
    const header = document.querySelector('#header-group > .header-section');
    const headerH = header ? Math.min(96, Math.max(0, header.getBoundingClientRect().height)) : 0;
    const from = owner.scrollTop;
    const offset = isDoc ? 0 : owner.getBoundingClientRect().top;
    const max = owner.scrollHeight - owner.clientHeight;
    const to = Math.max(0, Math.min(max, from + target.getBoundingClientRect().top - offset - headerH - 10));
    if (Math.abs(to - from) < 2) return;

    cancelAnimationFrame(anim);
    const prev = [owner.style.getPropertyValue('scroll-behavior'), owner.style.getPropertyPriority('scroll-behavior')];
    owner.style.setProperty('scroll-behavior', 'auto', 'important');
    const restore = () => {
      if (prev[0]) owner.style.setProperty('scroll-behavior', prev[0], prev[1]);
      else owner.style.removeProperty('scroll-behavior');
    };
    if (reduced.matches) { owner.scrollTop = to; restore(); return; }
    const distance = Math.abs(to - from);
    const duration = Math.min(900, Math.max(450, distance * 0.14));
    const t0 = performance.now();
    const ease = (t) => 1 - Math.pow(1 - t, 3);
    const step = (now) => {
      const t = Math.min(1, (now - t0) / duration);
      owner.scrollTop = from + (to - from) * ease(t);
      if (t < 1) anim = requestAnimationFrame(step);
      else { anim = 0; restore(); }
    };
    anim = requestAnimationFrame(step);
  }

  // Any new touch or wheel hands control back to the user immediately.
  const stop = () => { if (anim) { cancelAnimationFrame(anim); anim = 0; } };
  document.addEventListener('touchstart', stop, { passive: true, capture: true });
  document.addEventListener('wheel', stop, { passive: true, capture: true });

  document.addEventListener('click', (e) => {
    const cue = e.target instanceof Element ? e.target.closest('[data-pdpref-dock] [data-04-swipe-down-details]') : null;
    if (!cue) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    scrollToDetails(cue.closest('[data-pdpref-dock]'));
  }, true);
})();
